import { Button, HStack, Icon, Text } from "@chakra-ui/react";
import type { NavItemProps } from "./types";
import { activeNavButtonStyles, inactiveNavButtonStyles, collapsedNavButtonStyles } from "./styles";

const NavItemComponent = ({ item, isActive, onClick, isCollapsed = false }: NavItemProps) => {
  const getButtonStyles = () => {
    const baseStyles = isActive ? activeNavButtonStyles : inactiveNavButtonStyles;
    return isCollapsed ? { ...baseStyles, ...collapsedNavButtonStyles } : baseStyles;
  };

  return (
    <Button 
      {...getButtonStyles()} 
      onClick={onClick}
      title={isCollapsed ? item.name : undefined}
    >
      {isCollapsed ? (
        <Icon as={item.icon} boxSize={4} />
      ) : (
        <HStack gap={3} w="full">
          <Icon as={item.icon} boxSize={4} />
          <Text>{item.name}</Text>
        </HStack>
      )}
    </Button>
  );
};

export default NavItemComponent; 